// components/OrganizationSchema.js
"use client";

import Script from "next/script";

export default function OrganizationSchema() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "GovernmentOrganization",
    "name": "Official Website of Vigilance and Anti-Corruption Bureau",
    "url": "https://vigilance.kerala.gov.in/",
    "logo": "https://vigilance.kerala.gov.in/logo/logonew.svg",
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "",
      "contactType": ""
    },
    "sameAs": [
      "https://www.facebook.com/vigilancekerala/",
      "https://x.com/KeralaVigilance",
      "https://www.instagram.com/vigilancekerala/",
      "https://www.youtube.com/@vigilancekearala"
    ]
  };

  return (
    <Script
      id="organization-schema"
      type="application/ld+json"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}
